import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ContactsService } from 'app/modules/contacts/contacts.service';
import { Contact } from 'app/modules/contacts/contacts.types';
import { AccountService } from 'app/core';
import { PropertiesService } from '../../properties.service';

@Injectable({
  providedIn: 'root',
})
export class ContactsResolver {
  /**
   * Constructor
   *
   * @param {PropertiesService} _propertiesService
   * @param {ContactsService} _contactsService
   * @param {AccountService} _accountService
   */
  constructor(
    private _propertiesService: PropertiesService,
    private _contactsService: ContactsService,
    private _accountService: AccountService,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._propertiesService.accountId = accountData.id;
      this._contactsService.accountId = accountData.id;
    });
  }

  resolve(): Observable<Contact[]> {
    return this._propertiesService.getContacts();
  }
}
